import styled from 'styled-components'

const FormButton = styled.div`
  font-size: 28px;
  font-family: "Stick", sans-serif;
  background-color: #C9C6C6;
  padding: 8px;
  border: none;
  display: inline-block;
`

export default FormButton
